module.exports = __webpack_public_path__ + "img/icon-tree.b05101c1.png";